import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import moment from "moment";
import { Core } from "../helpers/core";
import { AppIcons } from "../constants/app-icons";
import { DOMAIN } from "./domain-constant";
import { Money } from "../helpers/money";

export default class InvoiceService extends ApiService {
  namespace = "salesReciept";
  previewNamespace = "invoice";
  template = "defaultTemplate";
  fullWindow = false;
  relations =
    "?expand=lineItems,layout,writeoffs,overPayments,headers,footers,messages,journals,files,files.file,files.file.commentsCount,customerName,salesRep";
  listingRelations = "customerName";
  icon = "Receipt";
  // icon = "Invoice";
  DOMAIN = DOMAIN.SALES_RECEIPTS;
  data = [];
  favicon = "Invoice";
  showLeftBar = false;
  enableSchedular = true;
  useNextNumber = true;
  labelKey = "number";
  name = this.terminology.salesReciept.plural;
  singular = this.terminology.salesReciept.singular;
  plural = this.terminology.salesReciept.plural;
  vowel = this.terminology.salesReciept.vowel;
  layout = 2;

  Width = 1300;
  gemItems = [
    {
      key: "listing",
      label: "All Sales Receipts",
      icon: AppIcons.BULLETS,
    },
    {
      key: "create",
      label: "Add a Sales Reciept",
      services: DOMAIN.SALES_RECEIPTS,
      icon: AppIcons.PLUS,
    },
    {
      key: "create",
      label: "Settings",
      services: DOMAIN.INVOICE_SETTING,
      icon: AppIcons.GEAR,
    },
  ];
  columns = [
    {
      header: this.t("number"),
      icon: AppIcons.SHRED,
      field: "number",
      width: "5",
      sortable: true,
    },
    {
      header: this.t("customer"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "customer",
      template: (data) =>
        data.customer?.display_name ?? data.customerName ?? "",
    },
    {
      header: this.t("date"),
      icon: AppIcons.GREEN_CALENDAR,
      field: "date",
      width: "5",
      sortable: true,
      template: (data) => {
        return Core.datey(data.date);
      },
    },

    {
      header: this.t("amount"),
      icon: AppIcons.MONEY,
      field: "total_amount",
      width: "7",
      sortable: true,
      template: (data) => Money.format(data.total_amount),
    },

    {
      header: this.t("status"),
      icon: AppIcons.LIGHTNING,
      field: "status",
      width: "5",
      statusIndicator: true,
      // template: (data) => {
      //   let statusTxt =
      //     data.status == 0
      //       ? "Open"
      //       : data.is_draft == 1
      //         ? " Draft"
      //         : data.is_template == 1
      //           ? " Template"
      //           : "Complete";
      //   if (data.is_tba == 1) statusTxt += ` (TBA)`;
      //   return statusTxt;
      // },
    },
  ];
  lineItems = [
    {
      key: "edit",
      label: "Apply Subtotal",
      icon: PrimeIcons.PENCIL,
    },
    {
      key: "announce",
      label: "Bank Line",

      icon: PrimeIcons.LIST,
    },
    {
      key: "email",
      label: "Discount",
      icon: PrimeIcons.ENVELOPE,
    },
    {
      key: "bookmark",
      label: "Good",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Inventory Item",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Other Change",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Over Payment",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Service",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      key: "bookmark",
      label: "Tax",
      icon: PrimeIcons.BOOKMARK,
    },
    {
      separator: true,
    },
    {
      key: "inactive",
      label: "Time & Expenses",
      icon: PrimeIcons.LOCK,
    },
  ];
  moreItems = [
    {
      key: "create",
      label: "Load template",
      icon: AppIcons.FOLDER,
      type: "1",
    },
    {
      key: "create",
      label: "Save and preview",
      icon: AppIcons.PREVIEW,
      type: "2",
    },
    {
      key: "create",
      label: "Save and print",
      icon: AppIcons.PRINTER,
      type: "3",
    },
    {
      key: "create",
      label: "Save and e-mail",
      icon: AppIcons.MAIL,
      type: "4",
    },
    {
      key: "create",
      label: "Manage layout",
      icon: AppIcons.LAYOUT,
      type: "5",
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.DISABLE,
    },
  ];
  getActionMenu(item) {
    const entity = this.singular;
    return [
      {
        key: "detail",
        label: this.t("previewThisEntity", { entity }),
        icon: "Eye",
      },
      {
        key: "edit",
        label: this.t("editThisEntity", { entity }),
        icon: AppIcons.EDIT,
      },
      {
        key: "announce",
        label: this.t("announceThisEntity", { entity }),
        services: DOMAIN.MESSAGES,
        icon: AppIcons.ANNOUNCEMENT,
      },
      {
        key: "email",
        label: this.t("emailThisEntity", { entity }),
        icon: AppIcons.MAIL,
        services: DOMAIN.EMAIL,
      },
      {
        key: "bookmark",
        label: this.t("bookmarkThisEntity", { entity }),
        icon: AppIcons.BOOKMARK,
      },
    ];
  }
  listMenuItems = [
    {
      key: "edit",
      label: this.t("editThisEntity", { entity: this.singular }),
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: this.t("announceThisEntity", { entity: this.singular }),
      services: DOMAIN.MESSAGES,
      icon: AppIcons.ANNOUNCEMENT,
    },
    {
      key: "email",
      label: this.t("emailThisEntity", { entity: this.singular }),
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: this.t("bookmarkThisEntity", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "create",
      label: this.t("copyThisEntity", { entity: this.singular }),
      icon: AppIcons.COPY,
      serviceId: DOMAIN.COPY_PAYABLES,
    },
    {
      key: "exec",
      label: this.t("printThisEntity", { entity: this.singular }),
      icon: AppIcons.PRINTER,
      action: (item, ctx) => {
        ctx.$emit("print", item);
      },
    },
    {
      key: "viewJournal",
      label: this.t("viewJournal"),
      icon: AppIcons.JOURNAL_VIEW,
    },
  ];
  permissions = [
    {
      key: "is_template",
      display_name: "Template",
      icon: AppIcons.TEMPLATE,
      value: 1,
    },
    {
      key: "is_draft",
      display_name: "Draft",
      icon: AppIcons.DOCUMENT_WITH_TEXT,
      value: 1,
    },
    {
      key: "status",
      display_name: "Completed",
      icon: AppIcons.MONEY,
      value: 1,
    },
    {
      key: "is_in_print_que",
      display_name: "Print Que",
      icon: AppIcons.FAX,
      value: 1,
    },
    {
      key: "is_in_email_que",
      display_name: "Email Que",
      icon: AppIcons.MAIL,
      value: 1,
    },
  ];
  filterItems = [
    { name: "Status", key: "status", value: "2", realm: "2" },
    { name: "Date", key: "date", value: "3", realm: "1" },
    { name: "Due Date", key: "due", value: "4", realm: "0" },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding a Sales Receipt",
      icon: PrimeIcons.LIST,
    },
  ];
  invoiceData = {
    ar_account: "2",
    billing_address: "this is billing address",

    customer: "2",

    customer_message: "this is customer message",

    date: "2022-01-31",
    delivery_address: "this is delivery address",

    delivery_date: "2",

    delivery_method: "2",

    delivery_tracking_number: "2221",

    due_date: "2022-01-31",

    incoterms: "3",

    incoterms_point: "this is incoterms point table",

    is_approved: "0",

    is_draft: "0",

    is_tba: "0",
    is_template: "0",

    job: "2",
    layout: "2",

    number: "2101",
    purchase_order_number: "112211",

    sales_rep: "2101",

    sales_rep_type: "17",

    tax: "2101",

    template: "2101",

    terms: "1",

    total_amount: "2101",
  };

  constructor() {
    super("ar-sales-receipts");
  }
}
